import { useState } from "react";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import GallerySection from "@/components/GallerySection";
import UpcomingEventsSection from "@/components/UpcomingEventsSection";
import GirlsNightSection from "@/components/GirlsNightSection";
import PrivatePartiesSection from "@/components/PrivatePartiesSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import BookingModal from "@/components/BookingModal";

const LandingPage = () => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState("standard");

  const openBooking = (packageType = "standard") => {
    setSelectedPackage(packageType);
    setIsBookingOpen(true);
  };

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#050505] text-white overflow-x-hidden">
      <Navbar onBookClick={() => openBooking()} />
      
      <main>
        <HeroSection onBookClick={() => openBooking()} />
        
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <ServicesSection />
        </motion.div>

        <div className="section-divider my-8" />
        
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <GallerySection />
        </motion.div>

        <div className="section-divider my-8" />

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <UpcomingEventsSection onBookClick={openBooking} />
        </motion.div>

        <div className="section-divider my-8" />
        
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <GirlsNightSection onBookClick={openBooking} />
        </motion.div>

        <div className="section-divider my-8" />
        
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <PrivatePartiesSection onBookClick={() => openBooking("private")} />
        </motion.div>

        <div className="section-divider my-8" />
        
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <ContactSection />
        </motion.div>
      </main>

      <Footer />

      <BookingModal 
        isOpen={isBookingOpen} 
        onClose={() => setIsBookingOpen(false)}
        initialPackage={selectedPackage}
      />
    </div>
  );
};

export default LandingPage;
